import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { FcpButtonModule, FcpIconModuleSVG } from 'fc-ui-components';
import { SignupVerifyEmailComponent } from './verify-email.component';

@NgModule({
    imports: [CommonModule, TranslateModule, FcpButtonModule, FcpIconModuleSVG],
    declarations: [SignupVerifyEmailComponent],
    exports: [SignupVerifyEmailComponent]
})
export class SignupVerifyEmailModule {}
